import { HOSES_ROLES_VIEWS_PERMISSIONS } from '@dep-hoses/utils/roles-actions';
import { SideBarButton } from '../../../settings/nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../../settings/nav-list/recursive-sidebar/configuration/preconfig';

export const HOSES_SIDENAV_OPTIONS: SideBarButton = {
  data: {
    name: 'Mangueras',
    appendUrl: './hoses',
    roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sideNavActions.root], // acción root creada
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Proceso',
        url: '/scheduling',
        otherUniqueUrls: [
          '/scheduling/hoses-inspection',
          '/scheduling/trimming',
          '/scheduling/qc',
        ],
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.routerActions.scheduling],
      },
      options: {},
    },
    {
      data: {
        name: 'Proceso',
        url: '/scheduling/machines-operator',
        roles: [
          ...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions
            .schedulingMachinesOperator,
        ],
      },
      options: {},
    },
    {
      data: {
        name: 'Cortes',
        url: '/only-trimming',
        roles: [
          ...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.schedulingOnlyTrimming,
        ],
      },
      options: {},
    },
    {
      data: {
        name: 'Control de calidad',
        url: '/quality-control',
        roles: [
          ...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions
            .schedulingQualityControl,
        ],
      },
      options: {},
    },
    {
      data: {
        name: 'Rechazado QC',
        url: '/qc-rejected',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.qcRejected],
      },
      options: {},
    },
    {
      data: {
        name: 'Horno',
        url: '/oven',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.oven],
      },
      options: {},
    },
    {
      data: {
        name: 'Moldes',
        url: '/molds',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.molds],
      },
      options: {},
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.validation],
      },
      options: {},
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.packingBox],
      },
      options: {},
    },
    {
      data: {
        name: 'Agregar datos QC',
        url: '/add-qc-data',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.addQcData],
      },
      options: {},
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/hoses',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Destinos',
        url: '/destinations',
        roles: [...HOSES_ROLES_VIEWS_PERMISSIONS.sharedActions.destinations],
      },
      options: {},
    },
  ],
};
